import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBanner, updateBanner } from 'slice/bannerSlice';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { getUploadUrl } from 'utils/uploadUrl';

const UpdateBanner = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, oneData } = useSelector((state) => state.banner);
    const [formData, setFormData] = useState({
        title: '',
        heading: '',
        description: '',
        image: null,
    });

    useEffect(() => {
        dispatch(getOneBanner(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData && Object.keys(oneData).length > 0) {
            setFormData({
                title: oneData.title || '',
                heading: oneData.heading || '',
                description: oneData.description || '',
                image: oneData.image || null
            });
        }
    }, [oneData]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('title', formData.title);
            formDataToSend.append('heading', formData.heading);
            formDataToSend.append('description', formData.description);
            if (formData.image instanceof File) {
                formDataToSend.append('image', formData.image);
            }

            dispatch(updateBanner({ id: id, data: formDataToSend }));
            toast('Banner updated successfully!');
            navigate('/khajuraho/banners');
        } catch (error) {
            console.error('Error updating banner:', error.message);
        }
    };

    return (
        <div className='container-fluid mt-5'>
            <div className='mainheadig mx-4'>
                <h4 className='text-white font-weight-bold '>Update Banner</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className='row'>
                    <div className='col-sm-12'>
                        <label className='adminlables'>
                            Small Title (e.g. UNESCO HERITAGE)
                            <input type='text' name='heading' value={formData.heading} className='form-control' onChange={handleChange} />
                        </label>
                    </div>
                    <div className='col-sm-12 mt-4'>
                        <label className='adminlables'>
                            Main Heading
                            <input type='text' name='title' value={formData.title} className='form-control' onChange={handleChange} />
                        </label>
                    </div>
                    <div className='col-sm-12 mt-4'>
                        <label className='adminlables'>
                            Description
                            <textarea name='description' value={formData.description} className='form-control' rows={3} onChange={handleChange}></textarea>
                        </label>
                    </div>
                    <div className='col-sm-12 mt-4'>
                        <label className='adminlables'>
                            Banner Image (Leave blank to keep current)
                            <input type='file' name='image' className='form-control btn-block filebg' onChange={handleChange} />
                        </label>
                    </div>
                    {oneData?.image && (
                        <div className="col-sm-12 mt-3">
                            <img src={getUploadUrl(oneData.image)} alt="" width={200} className="rounded shadow-sm" />
                        </div>
                    )}
                </div>
                <div className='mt-5 text-right'>
                    <button className='btn btn-lg addbtn' disabled={loading}>{loading ? 'Updating...' : 'Update Banner'}</button>
                </div>
            </form>
        </div>
    );
};

export default UpdateBanner;
